import { reducer as formReducer } from 'redux-form';

import { achievementsReducer } from '@/features/achievements';
import { activityReducer } from '@/features/activity';
import { aiTutorChatReducer } from '@/features/ai-tutor';
import { forgotPasswordReducer, signInReducer } from '@/features/auth';
import { bridgeReducer } from '@/features/bridge';
import { goalSettingsReducer } from '@/features/goalSettings';
import { onboardingReducer } from '@/features/onboarding';
import { progressReducer } from '@/features/progress';
import { stickersOnboardingReducer } from '@/features/stickersOnboarding';
import { wrappedReducer } from '@/features/wrapped';
import autonomyReducer from '@/pages/autonomy/Reducer';
import dailyGoalReducer from '@/pages/dailyGoal/Reducer';
import freePlayReducer from '@/pages/freePlay/Reducer';
import learningPathReducer from '@/pages/learningPath/Reducer';
import reportReducer from '@/pages/report/Reducer';
import playlistReducer from '@/playlist/Reducer';
import sharedReducer from '@/shared/Reducer';

import dailyReportReducer from '@/components/dailyReport/Reducer';
import errorBoundaryReducer from '@/components/errorBoundary/Reducer';
import errorHandlerReducer from '@/components/errorHandler/Reducer';
import addImageModalReducer from '@/components/modals/addImage/Reducer';
import confirmationReducer from '@/components/modals/confirmation/Reducer';
import difficultyModalReducer from '@/components/modals/difficulty/Reducer';
import doubleTabsModalReducer from '@/components/modals/doubleTabsModal/Reducer';
import gameExplanationReducer from '@/components/modals/gameExplanation/Reducer';
import imagePreviewReducer from '@/components/modals/imagePreview/Reducer';
import mistakeInterventionReducer from '@/components/modals/mistakeIntervention/Reducer';
import offlineRetryModalReducer from '@/components/modals/offlineRetryModal/Reducer';
import parentPasswordModalReducer from '@/components/modals/parentPasswordModal/Reducer';
import videoModalReducer from '@/components/modals/videoModal/Reducer';
import notificationReducer from '@/components/notification/Reducer';
import notificationsReducer from '@/components/notifications/Reducer';
import onboardingMessagesReducer from '@/components/onboardingMessages/Reducer';
import playButtonReducer from '@/components/playButton/Reducer';

import type { GoalSettingsState } from '@/features/goalSettings';

export type ReducerState<T> = T extends (...args: any[]) => infer R ? R : never;

export type RootStateOverrides = {
	achievementsReducer: any;
	autonomyReducer: any;
	freePlayReducer: any;
	goalSettingsReducer: GoalSettingsState;
	learningPathReducer: any;
	playlistReducer: any;
	reportReducer: any;
	sharedReducer: ReducerState<typeof sharedReducer> & {
		userData: any;
	};
};

export const reducers = {
	addImageModalReducer,
	achievementsReducer,
	activityReducer,
	aiTutorChatReducer,
	autonomyReducer,
	bridgeReducer,
	confirmationReducer,
	dailyGoalReducer,
	dailyReportReducer,
	difficultyModalReducer,
	doubleTabsModalReducer,
	errorBoundaryReducer,
	errorHandlerReducer,
	forgotPasswordReducer,
	form: formReducer,
	freePlayReducer,
	gameExplanationReducer,
	goalSettingsReducer,
	imagePreviewReducer,
	learningPathReducer,
	mistakeInterventionReducer,
	notificationReducer,
	notificationsReducer,
	offlineRetryModalReducer,
	onboardingMessagesReducer,
	onboardingReducer,
	parentPasswordModalReducer,
	playButtonReducer,
	playlistReducer,
	progressReducer,
	reportReducer,
	sharedReducer,
	signInReducer,
	stickersOnboardingReducer,
	videoModalReducer,
	wrappedReducer,
};

export type RootState = {
	[K in keyof typeof reducers]: K extends keyof RootStateOverrides
		? RootStateOverrides[K]
		: ReducerState<(typeof reducers)[K]>;
};
